import { render, staticRenderFns } from "./ElTableColumnTwoFields.vue?vue&type=template&id=7c8fb3fc&scoped=true"
import script from "./ElTableColumnTwoFields.vue?vue&type=script&setup=true&lang=ts"
export * from "./ElTableColumnTwoFields.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ElTableColumnTwoFields.vue?vue&type=style&index=0&id=7c8fb3fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8fb3fc",
  null
  
)

export default component.exports